export const isDevelopment = process.env.NODE_ENV === 'development';
export const servicetURL = process.env.REACT_APP_SERVICE_URL;
export const swissVatRateId = Number(process.env.REACT_APP_SWISS_VAT_RATE_ID);
export const timesheetsVatRateId = Number(process.env.REACT_APP_TIME_SHEETS_VAT_RATE_ID);
export const timesheetsAccountId = process.env.REACT_APP_TIME_SHEETS_ACCOUNT_ID;
export const saleAccountId = process.env.REACT_APP_SALE_ACCOUNT_ID;
export const ourContactId = process.env.REACT_APP_OUR_CONTACT_ID;
export const paymentAccountId = Number(process.env.REACT_APP_PAYMENT_ACCOUNT_ID);
